var _path, _rect, _rect2, _rect3, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpgrade(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "18_\u5347\u7EA7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.66,34.41l-9.08-5.82v-.86A26,26,0,0,0,43.86,12a20.93,20.93,0,0,0-8.22-7,8,8,0,0,0-7.45,0A22.92,22.92,0,0,0,20,12a28.09,28.09,0,0,0-4.72,15.77v1.05L6.16,34.6A5,5,0,0,0,4,38.74V43A5,5,0,0,0,9,48H55A5,5,0,0,0,60,43V38.53a4.94,4.94,0,0,0-2.3-4.14ZM8,43V38.69c0-.43,0-.79.36-1l7-4.52.08,10.78H9.07A1.29,1.29,0,0,1,8,43Zm23.84,1H19.12L19,27.73A20.55,20.55,0,0,1,30,8.18a4.35,4.35,0,0,1,4,0A20.55,20.55,0,0,1,45,27.73L45,44Zm24.15-1c0,.32-.44,1-.85,1h-6.4l-.08-11,7.08,4.51c.35.23.27.62.26,1Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 52,
    width: 4,
    height: 8,
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.95,
    y: 52,
    width: 4,
    height: 8,
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.98,
    y: 50,
    width: 4,
    height: 10,
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32,29.7A6.68,6.68,0,1,1,38.68,23,6.69,6.69,0,0,1,32,29.7Zm0-9.36A2.68,2.68,0,1,0,34.68,23,2.68,2.68,0,0,0,32,20.34Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgrade);
export default __webpack_public_path__ + "static/media/upgrade.42f709d9.svg";
export { ForwardRef as ReactComponent };